import React, {useState,useEffect} from 'react'
// import { createBrowserHistory } from "history";
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSearch, faAngleRight, faAngleDown, faTimes} from "@fortawesome/free-solid-svg-icons"
import MediaLibrary from "./MediaLibrary"
import { updateSetting } from '../util/api';
import { userRequest } from '../util/requestMethod';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function SiteSetting() {
  // const history = createBrowserHistory({ forceRefresh: true });
  const [siteInfo, setSiteInfo] = useState({});
  const [logo, setLogo] = useState(null);
  const id = siteInfo._id;
  const [modal, setModal] = useState(false)
  const [logoloader, setlogoloader] = useState(false);
  const menues = useSelector((state)=> state.menu.menues)
  const navigate = useNavigate()

  const getSiteInfo = async () => {
    try {
      const res = await userRequest.get("/siteSetting");
      setSiteInfo(res.data[0]);
      setLogo(res.data[0].siteLogo)
    } catch (error) {
      const res = "Something went wrong";
    }
  };

  useEffect(() => {
    getSiteInfo();
  }, []);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setSiteInfo({ ...siteInfo, [name]: value });
  };

  const handleUploadLogo = (e) => {
    e.preventDefault();
    setlogoloader(true);

    let uploaderLogo = {};
    if (logo) {
      setSiteInfo({ ...siteInfo, siteLogo: logo });
      uploaderLogo = { ...siteInfo, siteLogo: logo };
      updateSetting(id, uploaderLogo)
      .then(() => navigate('/sitesetting'));
      setlogoloader(false);
    }else{
      setSiteInfo({ ...siteInfo, siteLogo: "" });
      uploaderLogo = { ...siteInfo, siteLogo: "" };
      updateSetting(id, uploaderLogo)
      .then(() => navigate('/sitesetting'));
      setlogoloader(false);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    updateSetting(id, siteInfo)
    .then(() => navigate('/sitesetting'));
    // console.log(siteInfo);
  };

  const uploadImg = (childData) =>{
    setModal(!modal)
    setLogo(childData)
  }

  return (
    <>
    {modal? <div className="floating-media">
          <button className="close-modal" onClick={()=>setModal(!modal)}><FontAwesomeIcon icon={faTimes}/></button>
          <MediaLibrary className="author" uploadImg={uploadImg}/>
        </div> : ""}
    <div className="content-area-inner">
      <div className="container-fluid">
        <div className="pagination">
          <Link to="/">Dashboard</Link>
          <FontAwesomeIcon icon={faAngleRight} />
          <Link to="/">Site setting</Link>
        </div>
        <div className="heading">
          <h1>Site Settings</h1>
        </div>
        <form className="theme-form" onSubmit={handleClick}>
          <div className="row">
            <div className="col-lg-8">
              <div className="theme-card">
                <div className="theme-card-body">
                    <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Site Name</label>
                            <input type="text" tabIndex="1" value={siteInfo.siteName} name="siteName" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Site Title</label>
                            <input type="text" tabIndex="2" value={siteInfo.siteTitle} name="siteTitle" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Mobile</label>
                            <input type="text" tabIndex="3" value={siteInfo.contact1} name="contact1" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Other Phone</label>
                            <input type="text" tabIndex="4" value={siteInfo.contact2} name="contact2" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Email</label>
                            <input type="email" tabIndex="5" value={siteInfo.email} name="email" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Office Address</label>
                            <input type="text" tabIndex="6" value={siteInfo.address} name="address" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Twitter</label>
                            <input type="text" tabIndex="7" value={siteInfo.twitter} name="twitter" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Facebook</label>
                            <input type="text" tabIndex="8" value={siteInfo.facebook} name="facebook" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Youtube</label>
                            <input type="text" tabIndex="9" value={siteInfo.youtube} name="youtube" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Instagram</label>
                            <input type="text" tabIndex="10" value={siteInfo.instagram} name="instagram" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Description</label>
                            <textarea className="form-control" onChange={handleChange} tabIndex="11" name="siteDescription" value={siteInfo.siteDescription}  style={{height:"238px"}} placeholder="Input Here"></textarea>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Copyright</label>
                            <input type="text" tabIndex="12" value={siteInfo.copyright} name="copyright" className="form-control" onChange={handleChange} placeholder="Input Here"/>
                          </div>
                          <div className="form-group">
                            <label>Footer Menu 1</label>
                            <select className="form-control" name="footerMenu1" onChange={handleChange}>
                                {siteInfo.footerMenu1? <option value={siteInfo.footerMenu1}>{menues.filter(menu => menu._id === siteInfo.footerMenu1).map((menu) => (menu.item))}</option> : <option value="">Select Footer Menu 1</option>}
                                {menues.filter(menu => menu.place === "footer").map((menu) => (
                                  <option value={menu._id}>{menu.item}</option>
                                ))}
                            </select> 
                          </div> 
                          <div className="form-group">
                            <label>Footer Menu 2</label>
                            <select className="form-control" name="footerMenu2" onChange={handleChange}>
                            {siteInfo.footerMenu2? <option value={siteInfo.footerMenu2}>{menues.filter(menu => menu._id === siteInfo.footerMenu2).map((menu) => (menu.item))}</option> : <option value="">Select Footer Menu 2</option>}
                                {menues.filter(menu => menu.place === "footer").map((menu) => (
                                  <option value={menu._id}>{menu.item}</option>
                                ))}
                            </select> 
                          </div> 
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Delivery Charge Inside Dhaka</label>
                            <input type="number" tabIndex="14" value={siteInfo.delChargeInDhaka} name="delChargeInDhaka" className="form-control" onChange={handleChange} placeholder="Inside Dhaka"/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Delivery Charge Outside Dhaka</label>
                            <input type="number" tabIndex="14" value={siteInfo.delChargeOutDhaka} name="delChargeOutDhaka" className="form-control" onChange={handleChange} placeholder="Outside Dhaka"/>
                          </div>
                        </div>
                    <div>
                </div>
              </div>
            </div>
              </div>
              <div className="group-btn">
                  <button className="btn theme-btn" type="submit">Update</button>
                  {/* <button className="btn theme-btn-alt">Cancel</button> */}
              </div>
            </div>
            <div className="col-lg-3">
              <div className="theme-card">
                <div className="theme-card-body">
                  {logo ?
                    <img src={`${process.env.REACT_APP_BASE_URL}/api/alluploads/${logo}`} className="w-100" onClick={uploadImg} />
                    :
                  logo === null?

                    <img src={`${process.env.REACT_APP_BASE_URL}/api/alluploads/${siteInfo.siteLogo}`} className="w-100" onClick={uploadImg} />
                  : 
                    <div className="form-group upload-img" onClick={uploadImg}>
                      <label>
                      <svg width="72" height="57" viewBox="0 0 72 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M68.0057 10.3334V7.00004H60.8858V10.3334H56.3326L52.7727 0.333374H19.1595L15.5995 10.3334H0.366455V57H71.5657V10.3334H68.0057ZM64.4458 50.3334H7.48638V17H20.733L24.293 7.00004H47.6392L51.1992 17H64.4458V50.3334Z" fill="#E1E1E1"/>
                        <path d="M35.9661 17C32.7977 17 29.7004 17.8797 27.066 19.528C24.4315 21.1762 22.3782 23.5189 21.1657 26.2597C19.9532 29.0006 19.636 32.0166 20.2541 34.9264C20.8722 37.8361 22.398 40.5088 24.6384 42.6066C26.8788 44.7044 29.7333 46.133 32.8408 46.7118C35.9484 47.2906 39.1694 46.9935 42.0966 45.8582C45.0239 44.7229 47.5258 42.8003 49.2861 40.3336C51.0464 37.8668 51.986 34.9667 51.986 32C51.9812 28.0231 50.2919 24.2104 47.2887 21.3983C44.2854 18.5862 40.2134 17.0044 35.9661 17ZM35.9661 40.3333C34.2059 40.3333 32.4852 39.8446 31.0216 38.9289C29.558 38.0132 28.4173 36.7117 27.7437 35.189C27.0701 33.6663 26.8938 31.9908 27.2372 30.3742C27.5806 28.7577 28.4283 27.2729 29.6729 26.1074C30.9176 24.942 32.5034 24.1483 34.2298 23.8268C35.9563 23.5052 37.7457 23.6703 39.372 24.301C40.9982 24.9317 42.3882 25.9998 43.3661 27.3702C44.3441 28.7407 44.866 30.3518 44.866 32C44.866 34.2101 43.9284 36.3298 42.2593 37.8926C40.5903 39.4554 38.3265 40.3333 35.9661 40.3333Z" fill="#E1E1E1"/>
                      </svg>
                      Click here to upload Images
                      </label>
                      <div className="preview-img">
                        <img className="w-100"/>
                      </div>
                    </div>
                  }
                  <button className="btn theme-btn w-100 m-0 mt-2" onClick={handleUploadLogo}>Upload</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    </>
  )
}
